import Color from 'color';
import { CSSProperties } from 'react';

const BlueText: CSSProperties = { color: '#2478a9' };

const MutedText: CSSProperties = { opacity: 0.6 };

const MergedTag: CSSProperties = { borderWidth: 1, borderColor: 'rgb(78, 159, 204)', borderStyle: 'dashed', boxSizing: 'border-box' };

const RedButtonColour = '#d70000';

const CyanColour = '#448cb4';

const BlueBorderColour = '#328fb9';

const GreyBackgroundColour = '#e2e2e2';

const LighterGreyBackgroundColour = '#f1f1f1';

const WhiteGreyBackgroundColour = '#f6f6f6';

const BlackTextColour = '#333';

const LightBlueHighlight = '#d9e8fb';

const WarningColour = '#faba5e';

const PurpleColour = 'rgba(110, 50, 192, 0.6)';

const LightPurpleColour = 'rgba(140, 128, 255, 0.25)';

const HoverLightGreenColour = Color('rgba(198,255,197, 0.7)');

const SelectionGreenColour = Color('rgba(180, 255, 105, 0.7)');

const YellowColour = Color('yellow');

const SuggestedBlueColour = Color('rgba(77,173,209,0.4)');

const ConfirmedBlueColour = Color('rgba(42,158,209, 0.6)');

const BlueColour = Color('rgba(11,140,209,0.6)');

const LightGreyColour = Color('lightgrey');

const NothingColour = Color('rgba(0,0,0,0)');

const RedColour = Color('rgb(215, 20, 20)');

const BlackColour = Color('rgb(51, 51, 51)');

const PurpleIconColour = Color('rgba(110, 50, 192, 1)');

const BlueIconColour = Color('rgba(33, 169, 213, 1)');

export {
  BlackColour,
  BlackTextColour,
  BlueBorderColour,
  BlueColour,
  BlueIconColour,
  BlueText,
  ConfirmedBlueColour,
  CyanColour,
  GreyBackgroundColour,
  HoverLightGreenColour,
  LightBlueHighlight,
  LighterGreyBackgroundColour,
  LightGreyColour,
  LightPurpleColour,
  MergedTag,
  MutedText,
  NothingColour,
  PurpleColour,
  PurpleIconColour,
  RedButtonColour,
  RedColour,
  SelectionGreenColour,
  SuggestedBlueColour,
  WarningColour,
  WhiteGreyBackgroundColour,
  YellowColour,
};
